import script from "./ProductAuthList.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductAuthList.vue?vue&type=script&setup=true&lang=js"

import "./ProductAuthList.vue?vue&type=style&index=0&id=7cb67b16&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7cb67b16"]])

export default __exports__